import React from 'react';

import type {
  GameTypesAndVariants,
  SplitWagerBonusMPNotification
} from '@swf/core/types/Notification';

import type { CardViewProps } from '../../config/NotificationTypes';
import CardBack from '../CardBack/Template';
import EligibleGames from '../EligibleGames/EligibleGames';

const InstantBonusBack: React.FC<CardViewProps> = (props) => {
  const {
    attributes: { longEligibleGameNames, shortEligibleGameNames, supportedGamesJson }
  } = props.cardData as SplitWagerBonusMPNotification;

  const allGamesSupported = (supportedGamesJson as GameTypesAndVariants[])[0]?.C?.length === 0;
  return (
    <CardBack {...props}>
      {longEligibleGameNames && <p>{longEligibleGameNames}</p>}
      {!allGamesSupported && !longEligibleGameNames && !shortEligibleGameNames && (
        <EligibleGames eligibleGameData={supportedGamesJson as GameTypesAndVariants[]} />
      )}
    </CardBack>
  );
};
export default InstantBonusBack;
